import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSchool: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconSchool"><Path fillRule="evenodd" clipRule="evenodd" d="M6 5.75C6 4.7835 6.7835 4 7.75 4H16.25C17.2165 4 18 4.7835 18 5.75V18.5H19V8H20.25C21.2165 8 22 8.7835 22 9.75V18.5H22.25C22.6642 18.5 23 18.8358 23 19.25C23 19.6642 22.6642 20 22.25 20H1.75C1.33579 20 1 19.6642 1 19.25C1 18.8358 1.33579 18.5 1.75 18.5H2V9.75C2 8.7835 2.7835 8 3.75 8H5V18.5H6V5.75ZM14 18.5V15.25C14 15.1119 13.8881 15 13.75 15H10.25C10.1119 15 10 15.1119 10 15.25V18.5H14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSchool;
